import { Injectable } from "@angular/core";
import { AbstractAuthenticationAppRouterService } from "@shopliftr/common-ng";
import { AppRouteId } from "../enums/app-route-id.enum";

/**
 * The base router service for the App
 */
@Injectable()
export class AppRouterService extends AbstractAuthenticationAppRouterService<AppRouteId> {

    get isReporting(): boolean {
        return this.isRouteActive(AppRouteId.Reporting);
    }

    get isDesigner(): boolean {
        return this.isRouteActive(AppRouteId.Designer);
    }

    toReporting(): void {
        this._navigateByRouteId(AppRouteId.Reporting);
    }

    toDesigner(): void {
        this._navigateByRouteId(AppRouteId.Designer);
    }
}
